import { render } from "./SelectedPeople.vue?vue&type=template&id=f9288042"
import script from "./SelectedPeople.vue?vue&type=script&lang=js"
export * from "./SelectedPeople.vue?vue&type=script&lang=js"

import "./SelectedPeople.vue?vue&type=style&index=0&id=f9288042&lang=scss"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__